import { PageHeader } from '../components/sections/PageHeader';
import { ProcessStepper } from '../components/sections/ProcessStepper';
import { DeliveryModel } from '../components/sections/DeliveryModel';
import { ContactCTA } from '../components/sections/ContactCTA';
import { REVIEW_CYCLE } from '../data/siteData';
import { Reveal } from '../hooks/useMotion';

export const HowWeWorkPage = () => (
  <div data-testid="how-we-work-page">
    <PageHeader eyebrow="How we work" title="A controlled BIM delivery structure">
      Built for quality, communication and scalability, with technical ownership kept by BuildiTech leadership
      throughout the project.
    </PageHeader>

    <section className="sec white">
      <div className="wrap">
        <Reveal className="hd">
          <div className="mono">BIM approach &amp; methodology</div>
          <h2>The BIM project lifecycle</h2>
          <p>Every project moves through the same six stages. Click a stage, or let the walkthrough play.</p>
        </Reveal>
        <ProcessStepper />
      </div>
    </section>

    <section className="sec">
      <div className="wrap">
        <Reveal className="hd">
          <div className="mono">Our delivery model</div>
          <h2>Controlled delivery, not unmanaged outsourcing</h2>
          <p>A dedicated client interface, India-based production and a QA/QC gate before every submission.</p>
        </Reveal>
        <DeliveryModel />
      </div>
    </section>

    <section className="sec white">
      <div className="wrap">
        <Reveal className="hd">
          <div className="mono">QA/QC &amp; delivery control</div>
          <h2>A clear review cycle keeps deliverables traceable and client-ready</h2>
          <p>Internal author–checker–approver review before submission.</p>
        </Reveal>
        <div className="cycle">
          {REVIEW_CYCLE.map((c, i) => (
            <Reveal key={c.title} delay={i * 80}>
              <span className="dot">{String(i + 1).padStart(2, '0')}</span>
              <h3>{c.title}</h3>
              <p>{c.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <ContactCTA />
  </div>
);

export default HowWeWorkPage;
